export function getReferralCodePath(workerId: string) {
  return `/workers/${workerId}/referral-codes`;
}

export function getWorkplaceSignUpWithReferralCodePath(referralCode: string) {
  return `/workplace/get-access?referral-code=${referralCode}`;
}
